<template>
  <div>
    <b-card header="Imágenes / Documentos" 
        class="galeria-imagenes card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showImagenes= !showImagenes">
        <i :class="showImagenes ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-btn class="card-header-add" 
          v-if="showImagenes"
          variant="primary" 
          size="sm"
          @click.prevent="agregarImagenes">
        <i class="fa fa-plus"></i>
      </b-btn>
      <b-collapse class="mt-2" v-model="showImagenes">
        <b-row v-if="seleccionImagenes">
          <b-col>
            <b-form>
              <b-form-group
                  description="Imágenes (jpg, png o jpeg) o Documentos PDF de hasta 3MB">
                <b-form-file 
                  v-model="files" 
                  class="mt-3" 
                  accept=".jpg, .png, .jpeg, .pdf" 
                  placeholder="Seleccione una o más imágenes o archivos, o arrastrelos hasta aquí"
                  multiple>
                </b-form-file>
                <b-input-group-append 
                  class="filter-search-icons" 
                  @click="agregarImagenes">
                  <b-input-group-text>
                    <i class="fa fa-remove"></i>
                  </b-input-group-text>
                </b-input-group-append>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="4" v-for="{ id, url, fileName, key } in imagenes" :key="key">
            <b-card no-header class="galeria-imagen">
              <template v-if="isImagen(fileName)">
                <b-img fluid
                  @click="consultarImagen(url)"
                  :src="url"></b-img>
              </template>
              <template v-if="isPDF(fileName)">
                <div class="galeria-pdf">
                  <i class="fa fa-file-pdf-o fa-2x" @click="consultarPDF(url, fileName)"></i>
                  <label @click="consultarPDF(url, fileName)">{{ fileName }}</label>
                </div>
                <!-- <label>PDF</label> -->
              </template>  
              <div class="footer">
                <b-button size="sm" variant="danger" class="footer-button" 
                  @click.prevent="borrarImagen(id)">Borrar</b-button>
                <!-- <b-button size="sm" variant="primary" class="footer-button" 
                  @click.prevent="descargarImagen(url, fileName)">Descargar</b-button> -->
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-collapse>
    </b-card>

    <b-modal ref="imagenModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalImagen">
      <app-imagen
        :url="selectedImageUrl"
        @close="closeImagen">
      </app-imagen>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Imagen from  '../shared/imagenModal.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'participanteDatos/getField',
  mutationType: 'participanteDatos/updateField',
});

export default {
  name: 'ParticipanteDatos',
  components: {
    appImagen: Imagen,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  data: () => {
    return {
      files: [],
      uploaded: [],
      seleccionImagenes: false,
      selectedImageUrl: '',
      
      showImagenes: false,
    }
  },
  computed: {
    ...mapFields([
      'imagenes',
    ]),
  },
  created() {
  },  
  methods: {
    isImagen(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'jpg' 
          || extension.toLowerCase() == 'png') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'jpeg') {
        return true;
      }

      return false;
    },
    isPDF(fileName) {
      let extension = fileName.slice(-3);
      if (extension == 'pdf') {
        return true;
      }
      return false;
    },
    borrarImagen (imagenId) {
      this.showModalConfirm('¿Desea eliminar la imagen o archivo seleccionado?', 
        this.borrar.bind(this, imagenId), 'Si', 
        null, 'No')
    },
    borrar(imagenId) {
      this.showSpinner();
      this.$store.dispatch('participanteDatos/removeImagen', imagenId)
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner())
    },
    agregarImagenes() {
      this.seleccionImagenes = !this.seleccionImagenes;
    },
    uploadFiles() {
      if (this.files) {
        if (this.files.length != 0) {
          this.uploaded = [];

          this.showSpinner();

          this.files.forEach(file => {
            let params = {
              ordenTrabajoId: this.ordenTrabajoId,
              file: file
            }

            this.uploaded.push(file);

            this.$store.dispatch('participanteDatos/addImagen', params)
              .then( () => this.fileUploaded(file))
              .catch( error => {
                this.hideSpinner();
                this.showErrorMsj (error);
              });
          });
        }
      }
    },
    fileUploaded(file) {
      console.log('Uploaded');

      let index = this.uploaded.findIndex(uploadedFile => uploadedFile.name == file.name);

      if (index != -1) {
        this.uploaded.splice(index, 1);

        if (this.uploaded.length == 0) {
          this.files = [];
          this.seleccionImagenes = false;
          this.hideSpinner();
        }
      }
    },
    descargarImagen(imageUrl, imagenName) {
      fetch(imageUrl)
        .then((response) => response.blob())
        .then((blob) => {
          saveAs(blob, imagenName);
        });
    },
    consultarImagen(imageUrl) {
      this.selectedImageUrl = imageUrl;
      this.$refs.imagenModal.show();
    },
    closeImagen() {
      this.$refs.imagenModal.hide();
    },
    consultarPDF(url, fileName) {
      window.open(url, '_blank');

      // fetch(url, { method: 'get', mode: 'no-cors', referrerPolicy: 'no-referrer' })
      //   .then(res => res.blob())
      //   .then(res => {
      //     const aElement = document.createElement('a');
      //     aElement.setAttribute('download', fileName);
      //     const href = URL.createObjectURL(res);
      //     aElement.href = href;
      //     aElement.setAttribute('target', '_blank');
      //     aElement.click();
      //     URL.revokeObjectURL(href);
      //   });
    }
  },
  watch: {
    'files' : function(newVal, oldVal) {
      this.uploadFiles();
    },    
  }   
}
</script>

<style>
</style>